import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function RetailSolutions() {
  return <DetailPage type="product" id="retail-solutions" />;
}
